import { language } from "shared/language";

export const PASSWORD_INVALID = language.password_invalid;
export const OLD_PASSWORD_INVALID = language.old_password_invalid;
export const USER_NOT_FOUND = language.user_not_found;
